import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Avatar,
  Dialog,
} from "@mui/material";
import { apiCallFollowingList } from "../../../../Core/Apicall";
import { useLocation } from "react-router-dom";
import CommonShimmer from "../../../Common/CommonShimmer/CommonShimmer";
import CommonPagination from "../../../Common/CommonPagination/CommonPagination";
import EmptyData from "../../../Common/EmptyData/EmptyData";
import moment from "moment";

const FollowingTab: React.FC = () => {
  const [tableData, setTableData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [totalItems, setTotalItems] = useState(0);
  const totalPages = Math.ceil(totalItems / rowsPerPage);

  const location = useLocation();
  const useData = location.state.user;

  const [selectedMediaForPreview, setSelectedMediaForPreview] = useState<
    any | null
  >(null);

  const handleApiCall = async (userId: any) => {
    setLoading(true);
    try {
      const data = {
        userId,
        offset: page,
        limit: rowsPerPage,
      };
      const res = await apiCallFollowingList(data);
      setTableData(res.data);
      setTotalItems(res?.totalCount || 0);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (useData) {
      handleApiCall(useData.userId ? useData.userId : useData._id);
    }
  }, [useData, page, rowsPerPage]);

  const handlePageChange = (value: number) => {
    setPage(value);
  };
  return (
    <Box sx={{ p: "20px" }}>
      <Paper
        className="scroll-bar"
        sx={{
          borderRadius: 3,
          overflow: "hidden",
          position: "relative",
        }}
      >
        <TableContainer className="scroll-bar">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Full Name</TableCell>
                <TableCell>Profile Image</TableCell>
                <TableCell>Date</TableCell>
              </TableRow>
            </TableHead>
            {loading === false && (
              <TableBody>
                {tableData.map((user: any, idx: number) => (
                  <TableRow key={user._id}>
                    <TableCell>{idx + 1}</TableCell>
                    <TableCell>{user.fullName || "-"}</TableCell>

                    <TableCell>
                      {user.profileImagePath ? (
                        <Avatar
                          src={user.profileImagePath}
                          alt="Profile"
                          sx={{ width: 50, height: 50, cursor: "pointer" }}
                          onClick={() =>
                            setSelectedMediaForPreview({
                              type: "Image",
                              url: user.profileImagePath,
                            })
                          }
                        />
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    <TableCell>
                      {moment(user.updatedAt).format("DD MMM YYYY")}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>

          {loading === true && (
            <div style={{ padding: "10px 10px" }}>
              <CommonShimmer />
            </div>
          )}
          {loading === false && <EmptyData data={tableData} />}
        </TableContainer>

        <CommonPagination
          page={page}
          rowsPerPage={rowsPerPage}
          totalItems={totalItems}
          totalPages={totalPages}
          onPageChange={(value) => handlePageChange(value)}
          onRowsPerPageChange={(value) => {
            setRowsPerPage(value);
            setPage(1);
          }}
        />
      </Paper>

      {/* Media Preview Dialog */}
      <Dialog
        open={!!selectedMediaForPreview}
        onClose={() => setSelectedMediaForPreview(null)}
      >
        {selectedMediaForPreview?.type === "Image" ? (
          <Avatar
            src={selectedMediaForPreview.url}
            variant="rounded"
            sx={{ width: 300, height: "auto" }}
          />
        ) : selectedMediaForPreview?.type === "Video" ? (
          <video width="300" controls autoPlay>
            <source src={selectedMediaForPreview.url} type="video/mp4" />
          </video>
        ) : selectedMediaForPreview?.type === "Audio" ? (
          <audio controls style={{ width: "300px" }} autoPlay>
            <source src={selectedMediaForPreview.url} type="audio/mpeg" />
          </audio>
        ) : null}
      </Dialog>
    </Box>
  );
};

export default FollowingTab;
